import './ImagesCollage.scss';
import { baseURL } from '../../../../utils/api';
import IEntityWithImage from '../../../../structures/interfaces/iEntityWithImage'
import { Popup } from 'semantic-ui-react';

interface ImagesCollageProps {
    items: IEntityWithImage[]
}

function ImagesCollage({items}:ImagesCollageProps) {
    return <div className='images-collage'>
    {items.filter(x=>x.promtForPhoto != '').map(x=><Popup basic inverted trigger={<div className='item'>
        <img alt={x.name} src={`${baseURL}/api/generatedImage/${x.imageId}`}/>
    </div>} content={x.name}/>)}
</div>;
};

export default ImagesCollage;